import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

export default function FAQ() {
  const { content: c } = useContent();
  const faqs = Array.isArray(c.faqs) ? c.faqs : [];
  const [open, setOpen] = useState(null);

  return (
    <div data-testid="faq-page" className="pt-28 md:pt-32">
      <section className="container-lux py-14 md:py-20 text-center">
        <Reveal>
          <p className="overline mb-6">FAQs</p>
          <h1 className="font-serif-lux text-4xl md:text-6xl font-light text-[#47562F] max-w-3xl mx-auto">
            {c.faq_heading || "Questions, answered."}
          </h1>
        </Reveal>
      </section>

      <section className="container-lux max-w-3xl mx-auto pb-24 md:pb-32">
        {faqs.length === 0 ? (
          <p className="text-center text-[#8a8a80] py-16">FAQs are coming soon.</p>
        ) : (
          faqs.map((f, i) => (
            <div key={i} className="border-b border-[#1A1A1A]/10" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(open === i ? null : i)}
                data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between gap-6 py-6 text-left"
              >
                <span className="font-serif-lux text-xl md:text-2xl text-[#1A1A1A]">{f.q}</span>
                <ChevronDown className={`text-[#8A9A6B] flex-shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} size={22} />
              </button>
              {open === i && (
                <p className="text-[#4A4A4A] leading-relaxed pb-6 -mt-1 whitespace-pre-line" data-testid={`faq-answer-${i}`}>{f.a}</p>
              )}
            </div>
          ))
        )}
      </section>

      <section className="py-16 text-center">
        <Reveal><Link to="/quote" className="btn-gold">Begin Your Journey</Link></Reveal>
      </section>
    </div>
  );
}
